import script from "./LibraryCatalogTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LibraryCatalogTable.vue?vue&type=script&setup=true&lang=js"

import "./LibraryCatalogTable.vue?vue&type=style&index=0&id=1ebade24&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebade24"]])

export default __exports__